export const canManage = (user, company) =>
  !!user?.isSuperAdmin || company?.type === 1 || company?.type === 2;
